import React from "react"
import api from "src/api"

/**
 * Справочник категорий подписок из монолита — тот же, что пользователь видит
 * в разделе «Подписки и уведомления» приложения. Уведомление дойдёт только
 * до тех, у кого выбранная категория включена.
 */
export function useNotificationCategories() {
  const [categories, setCategories] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    loadCategories()
  }, [])

  async function loadCategories() {
    setIsLoading(true)
    try {
      const { data } = await api.get("notification-categories", { useV2Api: true })
      setCategories(
        (data?.items ?? [])
          // Общий тумблер push и канал Email рассылке в качестве категории не назначаются.
          .filter((category) => category.availableForPush)
          .map((category) => ({
            label: category.name,
            value: category.slug,
          }))
      )
    } catch (error) {
      console.error("Ошибка загрузки категорий уведомлений", error)
    } finally {
      setIsLoading(false)
    }
  }

  return { categories, isLoading }
}
